export const GOVERNMENT_BUSINESS: string = 'GOVERNMENT_BUSINESS'
export const QUERY: string = 'QUERY'
export const ACTIVITY: string = 'ACTIVITY'
export const OFFLINE_TRACKER: string = 'OFFLINE_TRACKER'
export const STATUS: string = 'status'
export const NATURE_OF_ISSUE: string = 'natureOfIssue'
export const RECEIVED_MODE: string = 'receivedMode'
export const RECEIVED_DOCUMENTS: string = 'receivedDocuments'
export const ACKNOWLEDGE_SHARED_STATUS = 'acknowledgeSharedStatus'
export const MOBILE_COUNTRY_CODE = 'mobileCountryCode'
export const MOBILE_NUMBER = 'mobileNumber'
export const EMPLOYEE_STATUS = 'employeeStatus'
export const EMPLOYEE_CODE = 'employeeCode'
export const EMAIL_ID = 'emailId'
export const STATUS_DATE = 'statusDate'
